import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { IonRow } from "@ionic/react";
import { clsx } from "clsx";
import React, { ReactNode } from "react";

import "./SimpleLoading.css";
function SimpleLoading({
  iconProps,
}: {
  iconProps?: React.ComponentProps<typeof ArrowPathIcon>;
}): ReactNode {
  return (
    <IonRow className="ion-justify-content-center">
      <ArrowPathIcon
        width={50}
        role="svg"
        {...iconProps}
        className={clsx("spinner", iconProps?.className)}
      />
    </IonRow>
  );
}

export { SimpleLoading };
